import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { Button } from '@/components/ui/Button/Button';
import { FilterNoneIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Tooltip } from '@/components/ui/Tooltip/Tooltip';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * セミナー詳細へのリンクを表示するためのボタン
 * @param props
 * @constructor
 */
export const SeminarCliDetailButton = (props) => {
    const { buttonText, className = '', externalLinkAttributes, isFull, isShowIcon = false, noLinkElement, onClick, routerLinkAttributes, size, to, tooltipHtml, } = props;
    return (_jsx(DynamicLink, Object.assign({ className: className, externalLinkAttributes: externalLinkAttributes, noLinkElement: noLinkElement, onClick: onClick, routerLinkAttributes: routerLinkAttributes, target: '_blank', to: to }, { children: _jsx(Tooltip, Object.assign({ arrow: true, html: tooltipHtml }, { children: _jsx(Button, Object.assign({ className: clsx(noLinkElement && 'pointer-events-none'), color: 'orange', isFull: isFull, size: size }, { children: _jsxs(IconTextGroup, { children: [_jsx("span", Object.assign({ className: 'whitespace-nowrap' }, { children: buttonText })), isShowIcon && _jsx(FilterNoneIcon, { color: 'white', size: 'md' })] }) })) })) })));
};
